import React, { useEffect, useRef, useState } from "react";
// Side-effect import: defines the <popout-theme-probe> custom element.
import "~/utils/popoutWindowsRegistry";

// Returns [hostDoc, probe]: the document the component currently lives in
// (updates when FlexLayout adopts the panel into/out of a popout window — no
// React lifecycle fires on that move) and a hidden probe element that must be
// rendered inside the component's tree. Use hostDoc for portals/appendTo and
// hostDoc.defaultView for viewport math so overlays open in the window the
// panel is actually in (PoC #popout).
//
//   const [hostDoc, hostProbe] = useHostDocument();
//   ...
//   {hostProbe}
//   {createPortal(<Menu />, (hostDoc ?? document).body)}
export default function useHostDocument() {
  const ref = useRef(null);
  const [hostDoc, setHostDoc] = useState(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el._onDocumentChange = () => {
      const doc = el.ownerDocument;
      setHostDoc((prev) => (prev === doc ? prev : doc));
    };
    el._onDocumentChange();
    return () => {
      el._onDocumentChange = null;
    };
  }, []);

  const probe = (
    <popout-theme-probe
      ref={ref}
      data-host-document-probe=""
      style={{ display: "none" }}
    />
  );

  return [hostDoc, probe];
}
